import http from '@/api'

export const api = {
  getActivity (hash) {
    return http.get(`/eventor/public/activity/${hash}`)
  }
}
